import { render, staticRenderFns } from "./Products1.vue?vue&type=template&id=d668ce52&scoped=true&"
import script from "./Products1.vue?vue&type=script&lang=js&"
export * from "./Products1.vue?vue&type=script&lang=js&"
import style0 from "./Products1.vue?vue&type=style&index=0&id=d668ce52&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d668ce52",
  null
  
)

export default component.exports